import { Webhook, CheckCircle2, AlertTriangle } from 'lucide-react';
import { CopyUri } from './CopyUri';

export function XeroWebhookHint({ status }) {
  const ok = status.webhook_configured;
  const last = status.webhook_last_received_at ? new Date(status.webhook_last_received_at).toLocaleString('en-AU', { dateStyle: 'medium', timeStyle: 'short' }) : null;
  return (
    <div className="rounded-md border bg-muted/40 p-3 text-sm space-y-2" data-testid="xero-webhook-hint">
      <div className="flex items-center gap-2">
        <Webhook className="h-4 w-4 text-primary" />
        <p className="font-medium flex-1">Xero webhook — marks orders paid when you reconcile a payment in Xero</p>
        <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${ok ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`} data-testid="xero-webhook-status">
          {ok ? <CheckCircle2 className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />}{ok ? (last ? `Key set · last received ${last}` : 'Key set · waiting for Xero') : 'Webhook key missing'}
        </span>
      </div>
      <p className="text-xs text-muted-foreground">In your Xero app → <strong>Webhooks</strong>: tick <strong>Invoices</strong>, paste this as the <strong>Delivery URL</strong>, Save, then press <strong>Send "Intent to receive"</strong>. Use your live site address (www.greenhillcreekturf.com), not the preview.</p>
      <CopyUri value={`${window.location.origin}/api/xero/webhook`} testId="xero-webhook-uri" />
    </div>
  );
}
